import React from 'react';
import { useLocation } from 'react-router-dom';
import '../styles/main.scss';

const MenuHome = () => {
  // Get the current URL using the useLocation hook
  const location = useLocation();

  // Define an array of nav items with their respective URLs
  const navItems = [
    { name: 'Home', url: '/computer-science' },
    { name: 'Algorithms', url: '/computer-science/algorithms' },
    { name: 'Data Structures', url: '/computer-science/data-structures' },
    { name: 'Programming', url: '/computer-science/programming' },
  ];

  return (
    <div>
      <nav>
        <ul>
          {/* Map over the navItems array and render each nav item */}
          {navItems.map((item, index) => (
            <li key={index}>
              {/* Check if the current URL matches the item's URL exactly or if the current URL starts with the item's URL */}
              {(location.pathname === item.url && item.url === '/computer-science') || (location.pathname.startsWith(item.url) && item.url !== '/computer-science') ? (
                <span style={{ fontWeight: 'bold' }}>{item.name}</span>
              ) : (
                <a href={item.url}>{item.name}</a>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
};

export default MenuHome;
